// Screen 3: Colorful Dashboard
import React from 'react';

const ColorfulWatch = ({ btcPrice, stats }) => {
  return (
    <div style={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Inter, system-ui, sans-serif",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", // Purple gradient
      color: "#ffffff",
      padding: "2vw"
    }}>
      <div style={{ textAlign: "center", maxWidth: "70vw" }}>
        {/* Screen Indicator */}
        <div style={{ 
          fontSize: "1.5vw", 
          color: "rgba(255,255,255,0.7)", 
          marginBottom: "2vh",
          letterSpacing: "1px"
        }}>
          COLORFUL DASHBOARD
        </div>

        {/* Main Price with Shadow */}
        <div style={{
          fontSize: "9vw",
          fontWeight: "700",
          marginBottom: "3vh",
          color: "#ffffff",
          textShadow: "0 4px 20px rgba(0,0,0,0.3)",
          fontFamily: "Inter, system-ui, sans-serif"
        }}>
          {btcPrice === null ? "Loading..." : `$${btcPrice.toLocaleString()}`}
        </div>

        {/* Comprehensive Stats */}
        {stats && stats.timeframes && (
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "1.5vw",
            marginBottom: "2vh"
          }}>
            {["1h", "3h", "1d", "1w"].map(period => (
              <div key={period} style={{
                backgroundColor: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(10px)",
                borderRadius: "1.5vw",
                border: "1px solid rgba(255,255,255,0.2)",
                padding: "1.5vw",
                textAlign: "center"
              }}>
                <div style={{ 
                  color: "rgba(255,255,255,0.8)", 
                  fontSize: "1.6vw", 
                  marginBottom: "0.8vh",
                  fontWeight: "500"
                }}>
                  {period.toUpperCase()}
                </div>
                <div style={{
                  color: stats.timeframes[period] && stats.timeframes[period].change >= 0 ? "#4ade80" : "#fb7185",
                  fontSize: "2.4vw",
                  fontWeight: "600"
                }}>
                  {stats.timeframes[period] && stats.timeframes[period].change >= 0 ? "+" : ""}{stats.timeframes[period] && stats.timeframes[period].change || "0.0"}%
                </div>
                <div style={{
                  fontSize: "1.4vw",
                  color: "rgba(255,255,255,0.6)",
                  marginTop: "0.5vh"
                }}>
                  H: ${stats.timeframes[period] && stats.timeframes[period].high && stats.timeframes[period].high.toLocaleString() || "0"}
                </div>
                <div style={{
                  fontSize: "1.4vw",
                  color: "rgba(255,255,255,0.6)"
                }}>
                  L: ${stats.timeframes[period] && stats.timeframes[period].low && stats.timeframes[period].low.toLocaleString() || "0"}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Current Status */}
        {stats && stats.timeframes && (
          <div style={{
            backgroundColor: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(10px)",
            borderRadius: "1.2vw",
            border: "1px solid rgba(255,255,255,0.2)",
            padding: "1.2vw",
            fontSize: "1.8vw",
            color: "rgba(255,255,255,0.9)"
          }}>
            Trend: {stats.timeframes["1d"] && stats.timeframes["1d"].change >= 0 ? "📈 Bullish" : "📉 Bearish"} • 
            Vol: {Math.abs(stats.timeframes["1d"] && stats.timeframes["1d"].change || 0) > 3 ? "High" : "Normal"}
          </div>
        )}
      </div>
    </div>
  );
};

export default ColorfulWatch;



// WEBPACK FOOTER //
// ./src/screens/ColorfulWatch.js